import React from 'react'
import styled from 'styled-components'
import { device } from '../../../utils/helpers'
import { InputWrapper, Label, ErrorText } from './Common'

const StyledInput = styled.input`
  background: #F3F3F3;
  font-family: 'Barlow';
  border: none;
  font-size: 1.3em;
  box-sizing: border-box;
  padding: 15px 10px;
  width: 100%;
  outline: none;
  line-height: 1.4em;

  &:focus {
    border: 5px solid ${props => props.theme.color.borderSecondary};
  }

  @media ${device.tablet} {
    font-size: 1.09375vw;
    padding: 0.78125vw 0.5208333333333334vw;
    line-height: 1.1458333333333335vw;
    border-width: 3px;
  }

  @media ${device.laptopL} {
    border-width: 4px;
  }

  @media ${device.desktop} {
    border-width: 5px;
  }
  ${'' /*
  @media ${device.laptopL} {
    font-size: 1.2em;
    padding: 10px 8px;
    line-height: 1.2em;
  }

  @media ${device.desktop} {
    font-size: 1.3em;
    padding: 15px 10px;
    line-height: 1.4em;
  } */}
`

const Input = ({
  input,
  label,
  type,
  width,
  height,
  required,
  padding,
  meta: { touched, error, warning }
}) => (
  <InputWrapper width={width} padding={padding}>
    <Label htmlFor={input.name}>{required ? `${label}*` : label}</Label>
    <StyledInput {...input} type={type} />
    {touched && (error && <ErrorText>{error}</ErrorText>)}
  </InputWrapper>
)

export default Input



// WEBPACK FOOTER //
// ./src/components/UI/Form/Input.js